export default __webpack_public_path__ + "static/media/ide.657074f9.png";